import { IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import { AsetuksetIcon } from "src/components/icons/StepIcons";
import Report_SettingsModal from "./Report_SettingsModal";
import { useReportData } from "src/context/ReportContext";

export default function Report_SettingsButton() {
  const [isOpen, setIsOpen] = useState(false);
  const { tabValue, showCapacitySettings, setShowCapacitySettings } = useReportData();

  const handleClick = () => {
    if (tabValue === 2) setShowCapacitySettings(!showCapacitySettings);
    else setIsOpen(true);
  };

  return (
    <div>
      <Report_SettingsModal isOpen={isOpen} setIsOpen={setIsOpen} />
      <Tooltip disableInteractive title="Raporttiasetukset" placement="top">
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton style={{ marginRight: 10 }} onClick={handleClick} sx={{ height: 55 }}>
            <AsetuksetIcon />
          </IconButton>
        </div>
      </Tooltip>
    </div>
  );
}
